import { ApiClient } from 'src/api/client/ApiClient'
import { apiOps } from 'src/api/defs/apiOps'
import { ReportError as _ReportError } from 'src/api/defs/ReportError.type'

export type ReportError = _ReportError

export class ErrorReporter {
    constructor(private api: ApiClient) {}

    report = async (err: ReportError) => {
        console.debug('Reporting error', err)

        await this.api.do(apiOps.ErrorReporting.reportError, {
            data: err
        })
    }
}
